import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { CreateModal } from "../../../shared/components/Modal";
import useSaveMovimento from "../hooks/useSaveMovimento";
import { MovimentoForm } from "../types";
import { FormMovimentos } from "./Form/FormMovimentos";

interface CreateMovimentoModalProps {
  onCancel: () => void;
  visible: boolean;
}

export function CreateMovimentoModal({ onCancel, visible }: CreateMovimentoModalProps) {
  const { register, handleSubmit, reset, setValue, control, formState: { errors } } = useForm<MovimentoForm>();

  const { mutate: cadastrarContato, isLoading: LoadingButton} = useSaveMovimento(() => resetForm());

  async function onSubmit(data: MovimentoForm) {
    const formattedData = {
      ...data,
      ValorUnitarioReais: data.ValorUnitarioReais ? data.ValorUnitarioReais : 0,
      DescontoPorcentagem: data.DescontoPorcentagem ? data.DescontoPorcentagem / 100 : 0,
    }

    navigator.onLine &&
      await cadastrarContato(formattedData);

    if(!navigator.onLine) {
      Swal.fire({
        title: 'Sem conexão',
        text: 'Por favor, verifique a sua conexão com a internet e tente novamente.',
        icon: 'error',
        position: 'center',
        confirmButtonText: 'OK',
        confirmButtonColor: '#f27474'
      })
    }


  }

  function resetForm() {
    onCancel();
    reset();
  }

  return (
    <>
      <CreateModal
        title="Cadastro de movimento"
        isModalOpen={visible}
        onCancel={resetForm}
        onSubmit={handleSubmit(onSubmit)}
        isLoading={LoadingButton}
      >
        <FormMovimentos
          register={register}
          control={control}
          setValue={setValue}
          errors={errors}
        />
      </CreateModal>
    </>
  );
}
